import {registerExpressPaymentMethod} from '@woocommerce/blocks-registry';
import {getSetting} from '@woocommerce/settings';
import ExpressPaymentComponent from "./express-payment-component";
import {isAdminOnly, isCheckoutPage} from "../../utils";

const data = getSetting('ppcp_fastlane_data');

registerExpressPaymentMethod({
    name: 'ppcp_fastlane',
    canMakePayment: async () => {
        return !isAdminOnly() && isCheckoutPage();
    },
    content: <ExpressPaymentComponent data={data}/>,
    edit: <ExpressPaymentComponent data={data}/>,
    supports: {
        features: data.features
    }
});